<template>
  <div
    v-if="!del"
    @mouseover="mouseover"
    @mouseout="mouseout"
    :style="style"
    class="piaochuang"
  >
    <!--飘窗-->
    <div @click="out" class="chacha">
      <i class="el-icon-close"></i>
    </div>
    <a :href="href" target="_blank">
      <img :src="src" />
    </a>
  </div>
</template>
<script>
import random from "random";
export default {
  props: {
    href: {
      default: "#",
      type: String
    },
    src: {
      default: "",
      type: String
    },
    width: {
      default: 400,
      type: Number
    },
    height: {
      default: 300,
      type: Number
    }
  },
  data() {
    return {
      del: false, // 是否删除（隐藏）
      canmove: true, // 是否允许移动
      x: 0, // 定位点X
      y: 0, // 定位点Y
      mode: 1, // 移动模式
      th: null // 线程
    };
  },
  computed: {
    style() {
      return `top:${this.x}px;left:${this.y}px;`;
    }
  },
  mounted() {
    const that = this;
    this.mode = random.int(1, 4);

    // 计算开始
    this.x = random.int(0, window.innerHeight - this.height);
    this.y = random.int(0, window.innerWidth - this.width);
    this.th = setInterval(() => {
      that.move();
    }, 60);
    console.log("定时器", this.th);
  },
  methods: {
    // 判断是否切换移动模式
    changeMode() {
      if (
        this.x <= 0 ||
        this.y <= 0 ||
        this.x >= window.innerHeight - this.height ||
        this.y >= window.innerWidth - this.width
      ) {
        this.mode++;
        if (this.mode > 4) {
          this.mode = 0;
        }
      }
    },
    move() {
      this.changeMode();
      if (!this.canmove) {
        return false;
      }
      if (this.mode === 1) {
        this.x++;
        this.y++;
      } else if (this.mode === 2) {
        this.x++;
        this.y--;
      } else if (this.mode === 3) {
        this.x--;
        this.y--;
      } else if (this.mode === 4) {
        this.x--;
        this.y++;
      }
    },
    // 关闭
    out() {
      this.del = true;
      clearInterval(this.th);
    },
    mouseover() {
      this.canmove = false;
    },
    mouseout() {
      this.canmove = true;
    }
  },
  beforeDestroy() {
    clearInterval(this.th);
  }
};
</script>
<style lang="less" scoped>
.piaochuang {
  position: fixed;
  z-index: 100;
}
.chacha {
  cursor: pointer;
  color: white;
  cursor: pointer;
  background-color: #1a5ee7;
  position: absolute;
  right: 0px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  font-size: 18px;
  z-index: 101;
}
</style>
